/* eslint-disable react-hooks/exhaustive-deps */
import {
  salesContractListApi,
  deleteSalesContractApi,
  getAllSalesContractApi,
  createSalesContractCloneApi,
} from "../../../services/_sales";
import moment from "moment";
import { Link } from "react-router-dom";
import { DateRangePicker } from "rsuite";
import { useEffect, useRef, useState } from "react";
import Spinner from "../../../theme/Spinner";
import Pagination from "../../../components/Pagination";
import { CURRENCY } from "../../../components/Constants";
import { getLoginUserType, getPermissions } from "../../../context/AuthContext";
import { getBuyerNameListApi } from "../../../services/_buyer";
import { SalesContractStatus } from "../../../components/Enums";
import { errorToast, successToast } from "../../../components/Toast";
import { formatAmount, formatString } from "../../../components/Helper";
import "rsuite/DateRangePicker/styles/index.css";
import { Autocomplete, TextField } from "@mui/material";
import { getAllBrokerApi } from "../../../services/_broker";
import ReCAPTCHA from "react-google-recaptcha";
import VerifiedDocumentModal from "./sales-contract-form/VerifiedDocumentModal";
import CloneSalesContractModal, {
  SalesContractCloneFormType,
} from "./sales-contract-form/CloneSalesContractModal";

const SalesContractList = () => {
  const permissions = getPermissions();
  const { isAdmin } = getLoginUserType();
  const [records, setRecords] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [brokerList, setBrokerList] = useState([]);
  const [salesContractList, setSalesContractList] = useState([]);
  const [page, setPage] = useState<number>(1);
  const [perPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [applyFilter, setApplyFilter] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [filterContract_no, setFilterContract_no] = useState<string>("");
  const [filterBuyer_id, setFilterBuyer_id] = useState<string>("");
  const [filterBrokerId, setFilterBrokerId] = useState<string>("");
  const [filterStatus, setFilterStatus] = useState<string>("");
  const [dateRange, setDateRange] = useState(null);
  const [displayFilter, setDisplayFilter] = useState(false);
  const [sortKey, setSortKey] = useState<string>("");
  const [sortType, setSortType] = useState<string>("");
  const productRef = useRef<any>(null);
  const [isCaptchaVerified, setIsCaptchaVerified] = useState(false);
  const [showCaptcha, setShowCaptcha] = useState(false);
  const [verifiedDocumentStatus, setVerifiedDocumentStatus] =
    useState<boolean>(false);
  const [verifiedDocumentData, setVerifiedDocumentData] = useState<{
    sales_contract_id: string;
    verified_documents: string[];
  }>({ sales_contract_id: "", verified_documents: [] });

  const toggleFilter = async () => {
    setDisplayFilter(!displayFilter);
  };
  const [selectedItemId, setSelectedItemId] = useState<string | null>(null);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);
  const [selectedContractNo, setSelectedContractNo] = useState<string | null>(
    null
  );
  const [isOpenCloneSalesContractModal, setIsOpenCloneSalesContractModal] =
    useState<boolean>(false);

  const getSalesList = async (
    page: number,
    perPage: number,
    isFilter?: boolean,
    sortKey?: string,
    sortType?: string
  ) => {
    setLoading(true);
    let query = `page=${page}&per_page=${perPage}`;
    if (isFilter) {
      if (filterContract_no) {
        query += `&contract_no=${filterContract_no}`;
      }
      if (filterStatus) {
        query += `&status=${filterStatus}`;
      }
      if (dateRange) {
        query += `&from_date=${moment(dateRange[0]).format("YYYY-MM-DD")}`;
        query += `&to_date=${moment(dateRange[1]).format("YYYY-MM-DD")}`;
      }
      if (filterBuyer_id) {
        query += `&buyer_id=${filterBuyer_id}`;
      }
      if (filterBrokerId) {
        query += `&broker_id=${filterBrokerId}`;
      }
      if (sortKey && sortType) {
        query += `&sort_key=${sortKey}&sort_type=${sortType}`;
      }
    }
    const result: any = await salesContractListApi(query);
    if (result.isSuccess) {
      const totalPagesCount = Math.ceil(result.data.total_records / perPage);
      setTotalRecords(result.data.total_records);
      setTotalPages(totalPagesCount);
      setRecords(result.data.records);
    }
    setLoading(false);
  };

  const filterList = async () => {
    setApplyFilter(true);
    getSalesList(page, perPage, true);
  };

  const resetList = async () => {
    setPage(1);
    setApplyFilter(false);
    setFilterContract_no("");
    setFilterBuyer_id("");
    setFilterBrokerId("");
    setFilterStatus("");
    setDateRange(null);
    if (productRef.current) {
      productRef.current.clearValue();
    }
    getSalesList(page, perPage);
    setShowCaptcha(false);
    setIsCaptchaVerified(false);
    setSelectedItemId(null);
    setSelectedContractNo(null);
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  useEffect(() => {
    if (page && perPage) {
      getSalesList(page, perPage, applyFilter);
    }
  }, [page, perPage, applyFilter]);

  useEffect(() => {
    const fetchBuyerBrokerData = async () => {
      const result: any = await getBuyerNameListApi();
      if (result.isSuccess) {
        setBuyerList(result.data);
      }
      const allBrokers: any = await getAllBrokerApi();
      if (allBrokers.isSuccess) {
        setBrokerList(allBrokers.data);
      }
    };
    const fetchSalesContractList = async () => {
      const sales: any = await getAllSalesContractApi();
      if (sales.isSuccess) {
        setSalesContractList(sales.data);
      }
    };
    fetchSalesContractList();
    if (isAdmin) {
      fetchBuyerBrokerData();
    }
  }, []);

  const handleCaptchaChange = (value: any | "") => {
    if (value) {
      setIsCaptchaVerified(true);
    }
  };

  const confirmDelete = async () => {
    setDeleteLoading(true);
    if (selectedItemId) {
      const result = await deleteSalesContractApi(selectedItemId);
      if (result.isSuccess) {
        await getSalesList(page, perPage);
        successToast(result.message);
      } else {
        errorToast(result.message);
      }
      setDeleteLoading(false);
      setSelectedItemId(null);
    }
  };
  const handleDeleteClick = (id: any) => {
    setSelectedItemId(id);
    setShowCaptcha(true);
  };
  const sortTable = async (key: string) => {
    let type = sortType === "asc" ? "desc" : "asc";
    if (sortKey !== key) {
      type = "asc";
    }
    setSortKey(key);
    setSortType(type);
    await getSalesList(page, perPage, true, key, type);
  };

  const handleVerifiedDocumentClick = async (item: any) => {
    setVerifiedDocumentStatus(true);
    setVerifiedDocumentData({
      sales_contract_id: item.id,
      verified_documents: item.verified_documents,
    });
  };
  const closeVerifiedDocumentModal = () => {
    setVerifiedDocumentStatus(false);
    setVerifiedDocumentData({ sales_contract_id: "", verified_documents: [] });
  };

  const toggleCloneModal = () => {
    if (isOpenCloneSalesContractModal) {
      setSelectedItemId(null);
      setSelectedContractNo(null);
      setIsCaptchaVerified(false);
    }
    setIsOpenCloneSalesContractModal(!isOpenCloneSalesContractModal);
  };
  const confirmClone = async (data: SalesContractCloneFormType) => {
    if (selectedItemId) {
      const result = await createSalesContractCloneApi({
        sales_contract_no: data.sales_contract_no,
        sales_contract_id: selectedItemId,
      });
      if (result.isSuccess) {
        await getSalesList(page, perPage);
        successToast(result.message);
        setIsCaptchaVerified(false);
        setSelectedItemId(null);
        setSelectedContractNo(null);
        toggleCloneModal();
      } else {
        errorToast(result.message);
      }
    }
  };

  return (
    <>
      <div className="card">
        <div className="card-header pb-0 d-flex justify-content-between">
          <div>
            <h5>Sales Contract List</h5>
          </div>
          <div>
            <Link
              to="#"
              type="button"
              className="btn btn-label-github"
              style={{ marginRight: "15px" }}
              onClick={toggleFilter}
            >
              <span>
                <i className="ti ti-filter me-sm-1"></i>{" "}
                <span className="d-none d-sm-inline-block">Filter</span>
              </span>
            </Link>
            {permissions.includes("create-sales-contract") && (
              <Link
                className="btn btn-primary waves-effect waves-light"
                type="button"
                to="/create-sales-contract"
              >
                <span>
                  <i className="ti ti-plus me-sm-1"></i>{" "}
                  <span className="d-none d-sm-inline-block">
                    Add Sales Contract
                  </span>
                </span>
              </Link>
            )}
          </div>
        </div>
        {displayFilter && (
          <div className="card-body">
            <form className="dt_adv_search">
              <div className="row">
                <div className="col-12">
                  <div className="row g-3">
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="date"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Contract Date:
                      </label>
                      <DateRangePicker
                        format="dd-MM-yyyy"
                        className="form-control"
                        placeholder="From Date ~ To Date"
                        value={dateRange}
                        onChange={(values: any) => {
                          setDateRange(values);
                        }}
                      />
                    </div>
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Contract No:
                      </label>
                      <Autocomplete
                        disablePortal
                        options={salesContractList.map(
                          (suggestion: any) => suggestion.contract_no
                        )}
                        onChange={(e, newValue) => {
                          setFilterContract_no(newValue);
                        }}
                        value={filterContract_no}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            className="form-control"
                            type="text"
                            placeholder="Enter Contract No"
                            value={filterContract_no}
                            onChange={(e) =>
                              setFilterContract_no(e.target.value)
                            }
                          />
                        )}
                      />
                    </div>
                    {isAdmin && (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label
                          htmlFor="buyer_id"
                          className="form-label"
                          style={{ fontSize: "0.9375rem" }}
                        >
                          Buyer:
                        </label>
                        <select
                          className="form-select"
                          id="buyer_id"
                          value={filterBuyer_id}
                          onChange={(e) => {
                            if (e.target.value) {
                              setFilterBuyer_id(e.target.value);
                            }
                          }}
                        >
                          <option defaultChecked value={""}>
                            Select Buyer
                          </option>
                          {buyerList.map((e: any) => {
                            return (
                              <option value={e.id} key={e.id}>
                                {e.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    )}

                    {isAdmin && (
                      <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                        <label
                          htmlFor="broker_id"
                          className="form-label"
                          style={{ fontSize: "0.9375rem" }}
                        >
                          Broker:
                        </label>
                        <select
                          className="form-select"
                          id="broker_id"
                          value={filterBrokerId}
                          onChange={(e) => {
                            if (e.target.value) {
                              setFilterBrokerId(e.target.value);
                            }
                          }}
                        >
                          <option defaultChecked value={""}>
                            Select Broker
                          </option>
                          {brokerList.map((e: any) => {
                            return (
                              <option value={e.id} key={e.id}>
                                {e.name}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    )}
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3">
                      <label
                        htmlFor="status"
                        className="form-label"
                        style={{ fontSize: "0.9375rem" }}
                      >
                        Status:
                      </label>
                      <select
                        className="form-select"
                        id="status"
                        value={filterStatus}
                        onChange={(e) => {
                          if (e.target.value) {
                            setFilterStatus(e.target.value);
                          }
                        }}
                      >
                        <option defaultChecked value={""}>
                          Select Status
                        </option>
                        <option
                          value={SalesContractStatus.PENDING}
                          key={SalesContractStatus.PENDING}
                        >
                          {formatString(SalesContractStatus.PENDING)}
                        </option>
                        <option
                          value={SalesContractStatus.IN_PROGRESS}
                          key={SalesContractStatus.IN_PROGRESS}
                        >
                          {formatString(SalesContractStatus.IN_PROGRESS)}
                        </option>
                        <option
                          value={SalesContractStatus.COMPLETED}
                          key={SalesContractStatus.COMPLETED}
                        >
                          {formatString(SalesContractStatus.COMPLETED)}
                        </option>
                      </select>
                    </div>
                    <div className="col-12">
                      <button
                        type="button"
                        className="btn btn-primary"
                        onClick={filterList}
                      >
                        Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-label-github ms-5"
                        onClick={resetList}
                      >
                        Reset
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        )}
        <div className="card-datatable table-responsive">
          {loading && <Spinner isFullScreen={false} />}
          <table className="dt-advanced-search table table-nowrap">
            <thead>
              <tr>
                <th>#</th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("contract_no")}
                >
                  Contract No
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th>Products</th>
                {isAdmin && (
                  <th
                    className="cursor-pointer"
                    onClick={() => sortTable("buyer")}
                  >
                    Buyer
                    <span>
                      <i className="ti ti-arrows-down-up sorting-icon"></i>
                    </span>
                  </th>
                )}
                {isAdmin && (
                  <th
                    className="cursor-pointer"
                    onClick={() => sortTable("broker")}
                  >
                    Broker
                    <span>
                      <i className="ti ti-arrows-down-up sorting-icon"></i>
                    </span>
                  </th>
                )}
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("total_amount")}
                >
                  Sub Total
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("status")}
                >
                  Status
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                <th
                  className="cursor-pointer"
                  onClick={() => sortTable("contract_date")}
                >
                  Contract Date
                  <span>
                    <i className="ti ti-arrows-down-up sorting-icon"></i>
                  </span>
                </th>
                {permissions.some((permission: any) =>
                  ["update-sales-contract", "delete-sales-contract"].includes(
                    permission
                  )
                ) && <th>Action</th>}
              </tr>
            </thead>
            <tbody>
              {records.length > 0 ? (
                records.map((item: any, i: number) => {
                  let statusClass = "";
                  if (item.status === SalesContractStatus.PENDING) {
                    statusClass = `bg-label-warning`;
                  } else if (item.status === SalesContractStatus.COMPLETED) {
                    statusClass = `bg-label-success`;
                  } else {
                    statusClass = `bg-label-secondary`;
                  }
                  return (
                    <tr key={item.id}>
                      <td>{(page - 1) * perPage + 1 + i}</td>
                      <td>
                        {
                          <Link to={`/view-sales-contract/${item.id}`}>
                            {item.contract_no}
                          </Link>
                        }
                      </td>
                      <td>
                        {item.sales_contract_product &&
                        item.sales_contract_product.length > 0
                          ? item.sales_contract_product
                              .map((p: any) => {
                                const name = p.products?.name;
                                const variety = p.products?.variety;
                                if (!name && !variety) return null;
                                if (name && variety) return `${name} - ${variety}`;
                                return name ?? variety ?? null;
                              })
                              .filter(Boolean)
                              .join(", ")
                          : "-"}
                      </td>
                      {isAdmin && <td>{item?.buyer?.name || ""}</td>}
                      {isAdmin && <td>{item?.broker?.name || ""}</td>}
                      <td>
                        {CURRENCY.USD.SYMBOL}
                        {formatAmount(item.sub_total)}
                      </td>
                      <td>
                        <span className={`badge ${statusClass} me-1`}>
                          {formatString(item?.status)}
                        </span>
                      </td>
                      <td>{moment(item.contract_date).format("DD-MM-YYYY")}</td>
                      {permissions.some((permission: any) =>
                        [
                          "create-sales-contract",
                          "update-sales-contract",
                          "delete-sales-contract",
                        ].includes(permission)
                      ) && (
                        <td>
                          {permissions.includes("create-sales-contract") && (
                            <div
                              className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                              onClick={() => {
                                setSelectedItemId(item.id);
                                setSelectedContractNo(item.contract_no);
                                toggleCloneModal();
                              }}
                              title="Create clone sales contract"
                            >
                              <i className="ti ti-copy"></i>
                            </div>
                          )}
                          {permissions.includes("update-sales-contract") && (
                            <>
                              <div
                                className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                                onClick={() =>
                                  handleVerifiedDocumentClick(item)
                                }
                                title="Verified documents"
                              >
                                <i className="ti ti-files"></i>
                              </div>
                              <Link
                                to={`/edit-sales-contract/${item.id}`}
                                className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                                title="Edit Sales Contract"
                              >
                                <i className="ti ti-pencil ti-md"></i>
                              </Link>
                            </>
                          )}
                          {permissions.includes("delete-sales-contract") && (
                            <div
                              className="btn btn-sm btn-text-secondary rounded-pill btn-icon"
                              data-bs-toggle="modal"
                              data-bs-target="#deleteSalesContractModal"
                              onClick={() => handleDeleteClick(item.id)}
                              title="Delete sales contract"
                            >
                              <i className="ti ti-trash"></i>
                            </div>
                          )}
                        </td>
                      )}
                    </tr>
                  );
                })
              ) : (
                <tr>
                  <td
                    colSpan={
                      permissions.includes("update-sales-contract") ? 11 : 10
                    }
                    className="text-center"
                  >
                    No records found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
          <div
            className="modal fade"
            id="deleteSalesContractModal"
            tabIndex={-1}
            aria-hidden="true"
          >
            <div className="modal-dialog modal-simple modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-body text-center">
                  <i
                    className="fa-solid fa-circle-exclamation"
                    style={{
                      fontSize: "48px",
                      color: "#ff4c51",
                      marginBottom: "20px",
                    }}
                  ></i>
                  <p style={{ fontSize: "25px" }}>Are you sure?</p>
                  <br />
                  <p style={{ fontSize: "20px" }}>
                    Do you want to delete this <b>sales contract</b>?
                    <br />
                    This action can't be undone!
                  </p>
                  {showCaptcha && (
                    <div
                      style={{
                        marginTop: "10px",
                        marginLeft: "50px",
                        marginBottom: "10px",
                      }}
                    >
                      <ReCAPTCHA
                        sitekey={
                          process.env.REACT_APP_GOOGLE_RECAPTCHA_SITE_KEY || ""
                        }
                        onChange={handleCaptchaChange}
                      />
                    </div>
                  )}
                  <div className="text-center">
                    <button
                      type="button"
                      className="btn btn-danger me-3"
                      onClick={() => {
                        confirmDelete();
                        resetList();
                      }}
                      disabled={deleteLoading || !isCaptchaVerified}
                      data-bs-dismiss="modal"
                    >
                      {deleteLoading && (
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                      )}
                      Yes, Delete
                    </button>

                    <button
                      type="button"
                      className="btn btn-label-secondary"
                      data-bs-dismiss="modal"
                      onClick={resetList}
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CloneSalesContractModal
          selectedContractNo={selectedContractNo}
          isOpenCloneModal={isOpenCloneSalesContractModal}
          toggleCloneModal={toggleCloneModal}
          confirmClone={confirmClone}
        />

        <VerifiedDocumentModal
          verifiedDocumentStatus={verifiedDocumentStatus}
          verifiedDocumentData={verifiedDocumentData}
          closeVerifiedDocumentModal={closeVerifiedDocumentModal}
          refetchSalesContractData={() =>
            getSalesList(page, perPage, applyFilter)
          }
        />

        <Pagination
          page={page}
          perPage={perPage}
          totalRecords={totalRecords}
          totalPages={totalPages}
          records={records}
          prevButton={prevButton}
          nextButton={nextButton}
        />
      </div>
    </>
  );
};

export default SalesContractList;
